<template>
    <div>
        <button class="d-none" id="openSyncOperation" @click="openModal()">operation</button>

        <div class="modal fade" id="syncOperationModal" tabindex="-1" aria-labelledby="syncOperationModal"
            aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Opérations préventives</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="ix-table-box mb-3">
                                    <table class="ix-table">
                                        <tbody>
                                            <tr v-for="(operation, index) in operations" v-if="!loading" :key="index">
                                                <td>
                                                    {{ operation.designation }}
                                                    <input type="hidden"
                                                        :name="'maintenanceOperation[' + index + '][maintenanceOperation_ids]'"
                                                        v-model="operation.id">
                                                    <input type="hidden"
                                                        :name="'maintenanceOperation[' + index + '][maintenanceOperation_designation]'"
                                                        v-model="operation.designation">
                                                </td>
                                                <td class="text-right">
                                                    <button type="button" class="btn btn-sm transparent"
                                                        @click="deleteRow(index)">
                                                        <i class="far fa-trash"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr v-if="loading">
                                                <td colspan="2" class="text-center">
                                                    <i class="far fa-circle-notch fa-spin"></i>
                                                </td>
                                            </tr>
                                            <tr v-show="!loading">
                                                <td colspan="2">
                                                    <input placeholder="Commencer la saisie pour obtenir des suggestions .."
                                                        class="form-control" id="operationSearchInput" type="text"
                                                        v-model="operation">
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="ix-btn green" @click="syncOperations()">
                            <span v-if="!loadingForm">Enregistrer</span>
                            <span v-if="loadingForm"><i class="far fa-circle-notch fa-spin"></i></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SyncOperation',
    props: ['url', 'operationUrl'],
    data() {
        return {
            operations: [],
            operation: null,
            loading: false,
            loadingForm: false,
        }
    },
    methods: {
        openModal: function () {
            $('#syncOperationModal').modal()
        },
        deleteRow(index) {
            this.operations.splice(index, 1)
        },
        addRow(operation) {
            if (operation && operation.id && this.getCurrentSelectedOperationId().includes(operation.id) == false && (this.exclude == undefined || (this.exclude != undefined && this.exclude != operation.id))) {
                this.operations.push({
                    id: operation.id,
                    designation: operation.designation,
                });
            }
        },
        getCurrentSelectedOperationId() {
            return this.operations.map(operation => operation.id);
        },
        syncOperations() {
            this.loadingForm = true;
            var data = {
                maintenanceOperation: this.operations.map((operation) => operation.id)
            };

            fetch(this.url, {
                ...this.getHttpJsonRequestHeaders(),
                ...{
                    method: 'PUT',
                    body: JSON.stringify(data)
                }
            }).then((response) => {
                this.loadingForm = false;
                if (response.ok) {
                    response.json().then((data) => {
                        location.reload()
                    })
                }
            }).catch((error) => {
                console.log(error);
                this.loadingForm = false;
            })
        }
    },
    async mounted() {
        $("#operationSearchInput").autocomplete({
            minLength: 0,
            source: (request, response) => {
                $.ajax({
                    url: this.operationUrl,
                    type: 'get',
                    dataType: 'json',
                    headers: this.getHttpJsonRequestHeaders().headers,
                    data: { q: request.term, '!id': this.getCurrentSelectedOperationId().join(';') + (this.exclude != undefined ? (';' + this.exclude) : ''), 'preventive': 'true' },
                    success: (data) => {
                        response($.map(data, (item) => {
                            return Object.assign(item, {
                                label: item.designation,
                                value: item.designation
                            })
                        }))
                    }
                });
            },
            change: (e, item) => {
                if (!item.item) {
                    this.addRow(this.operation);
                    $(e.target).val("");
                    this.operation = null
                }
            },
            select: (e, item) => {
                if (item.item) {
                    this.addRow(item.item)
                    $(e.target).val("")
                    this.operation = null
                }
            },
        }).focus(() => {
            $("#operationSearchInput").autocomplete("search", '');
        });
    }
}
</script>